export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_all-1d3c9a3914c148166ae8c87a964e84b1.png";